import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { endpoint: String, pkey: String, callbackUrl: String, redirectUrl: String}

  connect() {
    initEzidebitInputs() // This is defined in Ezidebit JS library
    $("#bankAccountForm").bootstrapMaterialDesign()
    this.initEzidebit()
    this.maskBsbInput()
  }

  initEzidebit() {
    const pkey = this.pkeyValue
    const endpoint = this.endpointValue

    eziDebit.init(pkey, {
      submitAction: "SaveCustomerAccount",
      submitButton: "signupBankAccountButton",
      submitCallback: (data) => this.submitSuccessCallback(data),
      submitError: (data) => this.displaySubmitError(data),
      customerReference: "systemReference", // In Ezidebit Online this is known as the Client Contract Ref. This is your reference for the customer
      customerLastName: "lastname",
      customerFirstName: "firstName", // If no first name is provided the customerLastName is assumed to be the Company Name
      customerAddress1: "address1",
      customerAddress2: "address2",
      customerSuburb: "suburb",
      customerState: "state",
      customerPostcode: "postcode",
      customerEmail: "email",
      customerMobile: "mobile",
      accountBSB: "bsb",
      accountName: "accountName",
      accountNumber: "accountNumber"
    }, endpoint);
  }

  maskBsbInput() {
    var selector = document.querySelector("#bsb");

    var im = new Inputmask("999-999");
    im.mask(selector);
  }

  submitSuccessCallback(data) {
    if (data["ErrorMessage"] != null) {
      this.displaySubmitError(data["ErrorMessage"])
    } else {
      let bankAccountData = data.Data

      Object.assign(bankAccountData, {
        bsb: $("#bsb").val(),
        bank_name:  $("#accountName").val(),
        masked_bank_account_no: maskString($("#accountNumber").val(), 0, 4),
        account_name: $("#accountName").val(),
        // The reference the customer was created under. Used by the
        // bank-account-only update callback to persist the new reference.
        YourSystemReference: $("#systemReference").val()
      });
      this.createPaymentMethod(bankAccountData)
    }
  }

  displaySubmitError(data) {
    const msg = data || "Failed to set up your direct debit. Please try again later.";

    bootbox.alert({
      title: formatBootboxTitle(false, "Failed"),
      className: "failure-modal",
      message: msg,
      callback: function () {
        enableSubmitButton("#signupBankAccountButton", "Submit")
      },
      closeButton: false
    })
  }

  createPaymentMethod(bankAccountData) {
    const url = this.callbackUrlValue
    const redirectUrl = this.redirectUrlValue

    const authenticityToken = $('#bankAccountForm input[name="authenticity_token"]').val();

    axios.post(url, { authenticity_token: authenticityToken, direct_debit: bankAccountData })
    .then(response => {
      bootbox.alert({
        title: formatBootboxTitle(true),
        className: "success-modal",
        message: "Your BANK ACCOUNT direct debit has been successfully set up.",
        callback: function () {
          window.location = redirectUrl;
        },
        closeButton: false
      });
    })
    .catch(error => {
      this.displaySubmitError(error);
    });
  }
}